import axiosInstance from './axiosInstance'

const getAllRewards = () => {
  return axiosInstance.get(`/api/reward/list`)
}

const deleteReward = (id: string | number) => {
  return axiosInstance.delete(`/api/admin/reward/${id}`)
}

const createReward = (
  file,
  title: string,
  shopName: string,
  website: string,
  code: string
) => {
  const formData = new FormData()
  formData.append('file', file)
  formData.append('title', title)
  formData.append('shopName', shopName)
  formData.append('website', website)
  formData.append('code', code)
  return axiosInstance.post(`/api/admin/reward`, formData)
}

const editReward = (
  file,
  title: string,
  shopName: string,
  website: string,
  code: string,
  id: string | number
) => {
  const formData = new FormData()
  if (file) {
    formData.append('file', file)
  }

  formData.append('title', title)
  formData.append('shopName', shopName)
  formData.append('website', website)
  formData.append('code', code)
  return axiosInstance.put(`/api/admin/reward/${id}`, formData)
}

const rewardsApi = {
  getAllRewards,
  deleteReward,
  createReward,
  editReward,
}

export default rewardsApi
